enum Errors {
  NOT_FOUND = "NOT FOUND",
  FORBIDDEN = "FORBIDDEN",
  SERVER_ERROR = "SERVER ERROR",
  ALREADY_CREATED = "ALREADY CREATED",
}

export default Errors;
